import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'zh', // 语言标识 //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    zh: require('./lang/language-zh'),
    en: require('./lang/language-en'),
    ja: require('./lang/language-ja')
  }
})
